export default __webpack_public_path__ + "static/webRotator/svg/fbd7d7eaaf6cddfc45d3b16d95a07602.svg";